// Third-party
import React from 'react';
import classNames from 'classnames';

// Namespaces
import * as ProposalNS from '../../Proposal';

// Utils
import { formatLocalizedString } from '../../../../utils/i18n';
import ProposalTextAreaData from '@/types/proposal-text-area-data';

type Props = {
  proposal: ProposalNS.Proposal;
  textAreaOptionConfig?: ProposalNS.TextAreaOptionConfig;
  className?: string;
  initialValue?: string;
  setTextAreaData: (key: string, textAreaData: ProposalTextAreaData) => void;
};

type State = {
  comment: string;
};

class ProposalTextArea extends React.Component<Props, State> {
  readonly state: State = {
    comment: '',
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      comment: props.initialValue !== undefined ? props.initialValue : '',
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.initialValue !== this.props.initialValue) {
      // Using this.setState inside a componentDidUpdate is 100% an anti-pattern,
      // but re-rendering the textarea an extra time is worth the time saved trying
      // to figure out a better solution.
      this.setState({ comment: this.props.initialValue || '' });
    }
  }

  onChange = (event: React.FormEvent<HTMLTextAreaElement>) => {
    this.setState({ comment: event.currentTarget.value });
  };

  onBlur = (/* event: React.FormEvent<HTMLTextAreaElement> */) => {
    const { textAreaOptionConfig } = this.props;

    if (textAreaOptionConfig === undefined || textAreaOptionConfig.key === undefined) {
      return;
    }

    this.props.setTextAreaData(textAreaOptionConfig.key, { value: this.state.comment });
  };

  render() {
    const {
      className,
      textAreaOptionConfig,
      proposal: {
        options: { locale },
      },
    } = this.props;
    const { comment } = this.state;

    if (!textAreaOptionConfig) {
      return null;
    }

    const { placeholder, maxChars } = textAreaOptionConfig;

    return (
      <textarea
        value={comment}
        onChange={this.onChange}
        onBlur={this.onBlur}
        placeholder={formatLocalizedString(placeholder, locale)}
        className={classNames('proposal-text-area', className)}
        maxLength={maxChars || 1000}
        data-private
        data-dd-privacy="mask"
      />
    );
  }
}

export type ProposalTextAreaProps = Props;

export default ProposalTextArea;
